import request from '@/utils/request'
import SERVICE from './enums'

// 获取自定义分析模型列表 
export function getAnalysisTemplates(data) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/analysisTemplates/page`,
    method: "post",
    data
  });
}

// 获取基础模型列表 
export function getSysDefaultTemplates(data) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/analysisTemplates/sysDefault`,
    method: "post",
    data
  });
}

// 复制基础模型 
export function copyBaseTemplate(id) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/analysisTemplates/sysDefault/${id}/copy`,
    method: "post",
    data: {}
  });
}

// 保存自定义分析模型
export function saveAnalysisTemplates(data) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/analysisTemplates`,
    method: "post",
    data
  });
}

// 获取分析模型详情
export function getAnalysisTemplatesDetails({id}) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/analysisTemplates/${id}`,
    method: "get"
  });
}
// 获取分析模型到media的详情
export function getAnalysisTemplatesMediaDetails() {
  return request({
    url: `${SERVICE.API_ANALYSIS}/templateShareInfo/share-media`,
    method: "get"
  });
}
// 删除分析模型前确认

export function  checkDeleteAnalysisTemplate (id) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/analysisTemplates/${id}/checkUse`,
    method: "get"
  });
}
// 删除分析模型
export function deleteAnalysisTemplate(id) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/analysisTemplates/${id}`,
    method: "delete",
    params: {
      confirm: true
    }
  });
}
// 更新分析模型
export function updateAnalysisTemplate(data, id) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/analysisTemplates/${id}`,
    method: "put",
    data
  });
}

// 分析模型预览图标数据
export function getWidgetsData(data) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/widgetAnalysis/analysis`,
    method: "post",
    data
  });
}

// 分析模型预览图标数据
export function getBaseWidgetsData(data) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/widgetAnalysis/example-analysis`,
    method: "post",
    data
  });
}

// 获取指标枚举
export function getEnumData(id) {
  return request({
    url: `${SERVICE.API_MEDIA}/dsTableField/${id}/dictValues`,
    method: "get",
  });
}

// 获取指标枚举
export function getEnumDataNew(tableId, field, data) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/templateShareInfo/without/values/${tableId}`,
    method: "post",
    data,
    params: {
      field
    }
  });
}

// 分析模型导出
export function templateExport(data) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/analysisTemplates/export`,
    method: "post",
    data
  })
}

// 品类分析-品类排行
export function analysisByCategory(data) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/dataAnalysisCategory/categoryAnalysisByCategory`,
    method: "post",
    data
  })
}

// 品类分析-国家排行
export function analysisByCountry(data) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/dataAnalysisCategory/categoryAnalysisByCountry`,
    method: "post",
    data,
  })
}

// 品类分析-品类趋势
export function trendByCategory(data) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/dataAnalysisCategory/queryDataCategoryTrend`,
    method: "post",
    data
  })
}

// 品类分析-国家趋势
export function trendByCountry(data) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/dataAnalysisCategory/queryDataCountryTrend`,
    method: "post",
    data,
  })
}

// 品类分析导出
export function exportMetaDataAnalysis(data) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/metaDataAnalysis/exportMetaDataAnalysis`,
    method: "post",
    data,
  })
}

// 品类趋势页面展示
export function getTrendCategory(data) {
  return request({
    url: `${SERVICE.API_MEDIA}/category/getTrendCategory`,
    method: "get",
    data
  })
}

// 国家趋势显示默认国家
export function queryTrendCountry(data) {
  return request({
    url: `${SERVICE.API_MEDIA}/dictCountry/queryTrendCountry`,
    method: "get",
    data,
  })
}

// 模型编辑中
export function modelEditing(id) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/templateShareInfo/editing/${id}`,
    method: "put",
    data: {}
  })
}

// 校验模型编辑权限
export function validExclusive(id) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/templateShareInfo/valid-exclusive/${id}`,
    method: "get"
  })
}

// 获取媒体后台路径
export function getTargetAccountName(data, field) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/templateShareInfo/without/getTarget/${field}`,
    method: "post",
    data
  })
}

// 内部分享分析模型导出
export function shareTemplateExport(data, reportCode) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/templateShareInfo/within/export/${reportCode}`,
    method: "post",
    data
  })
}